import { Component, Input } from '@angular/core';
import { DatePipe } from '@angular/common';
import { dateTimeFormat } from '../../../../models/date-formats';
import { Container } from '../../../../pages/overview/models/container';
import { Shipment } from '../../../../pages/overview/models/shipment';

@Component({
  selector: 'app-last-event',
  standalone: true,
  templateUrl: './last-event.component.html',
  imports: [DatePipe],
  styleUrl: './last-event.component.scss'
})
export class LastEventComponent {
  @Input() item: Shipment | Container | null = null;
  readonly dateTimeFormat = dateTimeFormat;
}
